var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAsset3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 204 57.99",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#e9aecf;}.cls-2{fill:#5d3233;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "base"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M78.76,12.37s-5.05,73.45,53.25,34S78.76,12.37,78.76,12.37Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Layer_4",
    "data-name": "Layer 4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M0,27.56c1.85-1.41,3.76-2.73,5.68-4s3.84-2.69,5.88-3.77A129.61,129.61,0,0,1,24,13.24c2.14-1,4.29-1.91,6.45-2.85s4.42-1.6,6.64-2.4c1.11-.4,2.22-.81,3.35-1.18s2.27-.65,3.4-1C46.1,5.21,48.38,4.55,50.68,4s4.65-1,7-1.44c1.16-.24,2.33-.45,3.5-.67l3.54-.48c2.37-.28,4.73-.64,7.11-.84S76.57.23,79,.1a155.64,155.64,0,0,1,28.61,1.52,159.36,159.36,0,0,1,53.78,18.2,152.27,152.27,0,0,1,23.31,15.84A127.32,127.32,0,0,1,195,45.16a81.7,81.7,0,0,1,9,10.72c-8.24-4.33-16.34-8.27-24.54-11.88s-16.35-7-24.61-9.86a269.23,269.23,0,0,0-50.2-12.74A238.62,238.62,0,0,0,79,19.05q-3.23-.06-6.45-.17c-2.16,0-4.31.05-6.47.07l-3.25,0-3.24.17-6.52.31c-2.16.24-4.34.39-6.52.58-1.09.1-2.19.17-3.28.29s-2.18.27-3.27.41c-2.19.26-4.37.56-6.59.79l-6.58,1.06-3.33.49c-1.12.14-2.19.44-3.31.62-2.21.41-4.42.85-6.67,1.22l-1.69.3-1.67.36-3.35.71C4.59,26.73,2.32,27.19,0,27.56Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAsset3);
export default __webpack_public_path__ + "static/media/Asset 3.f4914cf9.svg";
export { ForwardRef as ReactComponent };